import type { MenuConfig } from '~typings/menu'

import { permissionTree as permisos, RESOURCE_PRODUCCION_PG } from '@/auth/permissions/modules/produccionPg'
import {
    ROUTE_PPG_APROBACIONOP,
    ROUTE_PPG_APROBACIONOPSINANTICIPO,
    ROUTE_PPG_APROBACIONPRODUCTO,
    ROUTE_PPG_BANDEJAORDENTRABAJO,
    ROUTE_PPG_COSTOS,
    ROUTE_PPG_ORDENPEDIDO,
    ROUTE_PPG_ORDENTRABAJO,
    ROUTE_PPG_SOLICITUDCAMBIOOP,
} from '@/router/routes/producion-pg/nombres'
import { defineMenu } from '@/utils/menu'

const { transacciones } = permisos
export default defineMenu([
    {
        title: 'produccion_pg.subopciones.orden_pedido',
        resource: RESOURCE_PRODUCCION_PG,
        action: transacciones.orden_pedido,
        route: ROUTE_PPG_ORDENPEDIDO,
    },
    {
        title: 'produccion_pg.subopciones.orden_trabajo',
        resource: RESOURCE_PRODUCCION_PG,
        action: transacciones.orden_trabajo,
        route: ROUTE_PPG_ORDENTRABAJO,
    },
    {
        title: 'produccion_pg.subopciones.gestion_orden_trabajo',
        resource: RESOURCE_PRODUCCION_PG,
        action: transacciones.bandeja_orden_trabajo,
        route: ROUTE_PPG_BANDEJAORDENTRABAJO,
    },
    {
        title: 'produccion_pg.subopciones.aprobacion_producto',
        resource: RESOURCE_PRODUCCION_PG,
        action: transacciones.aprobacion_producto,
        route: ROUTE_PPG_APROBACIONPRODUCTO,
    },
    {
        title: 'produccion_pg.subopciones.aprobacion_op',
        resource: RESOURCE_PRODUCCION_PG,
        action: transacciones.aprobacion_op,
        route: ROUTE_PPG_APROBACIONOP,
    },
    {
        title: 'produccion_pg.subopciones.costos',
        resource: RESOURCE_PRODUCCION_PG,
        action: transacciones.costos,
        route: ROUTE_PPG_COSTOS,
    },
    {
        title: 'produccion_pg.subopciones.solicitud_cambio_op',
        resource: RESOURCE_PRODUCCION_PG,
        action: transacciones.solicitud_cambio_op,
        route: ROUTE_PPG_SOLICITUDCAMBIOOP,
    },
    {
        title: 'produccion_pg.subopciones.aprobacion_op_sin_anticipo',
        resource: RESOURCE_PRODUCCION_PG,
        action: transacciones.aprobacion_op_sin_anticipo,
        route: ROUTE_PPG_APROBACIONOPSINANTICIPO,
    },
] as MenuConfig[])
